import IPhoneXHelper from 'common/libs/IPhoneXHelper';
import React from 'react';
import Configs from 'utils/Configs';

export const ThemeContext = React.createContext();

export default class ThemeProvider extends React.PureComponent {
  static instance;

  constructor() {
    super();
    this.state = {
      darkMode: Configs.darkMode,
      fontSizeType: Configs.settings.fontSizeType,
      statusBarHeight: IPhoneXHelper.getStatusBarHeight(),
      bottomSpace: IPhoneXHelper.getBottomSpace()
    };
    ThemeProvider.instance = this;
  }

  render() {
    return <ThemeContext.Provider value={this.state}>{this.props.children}</ThemeContext.Provider>;
  }
}
